import React, { useMemo } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import SEO from '../../../../../components/seo';
import Hero from '../../../../../components/default/hero';
import Footer from '../../../../../components/default/footer';
import CookieMessage from '../../../../../components/default/cookieMessage';
import { WebNav } from '../../../../../components/default/navigation';
import { SignUpFormContainer } from './signup.form.container';
import { GoToButton } from './go.to.button';
import './landingPagesLayout.less';

const LandingPagesLayout = function ({
  children, title, pageTitle, imageFileName, imageTitle, imageAlt, headerImageExtraClass, location, language, imagePosition, description, keywords,
}) {
  const { t } = useTranslation();

  const nLocation = {
    pathname: '',
    search: '',
  };

  const { pathname, search } = location || nLocation;

  const customLinks = useMemo(() => ([
    {
      to: '#home',
      label: t('web.navigation.home'),
    },
    {
      to: '#why-lidya',
      label: t('web.navigation.why.lidya'),
    },
    {
      to: '#how-works',
      label: t('web.navigation.how.works'),
    },
    {
      to: '#about-us',
      label: t('web.navigation.about.us'),
    },
  ]), [t]);

  return (
    <div id="home">
      <SEO
        description={description}
        title={title}
        keywords={keywords}
        lang={language}
        pathname={pathname}
        search={search}
        pageTitle={pageTitle}
      />
      <div className="m-landingPageHero -bigger-space">
        <Hero
          imageFileName={imageFileName}
          imageTitle={imageTitle}
          imageAlt={imageAlt}
          headerImageExtraClass={headerImageExtraClass}
          imagePosition={imagePosition}
          title={title}
          customLinks={[]}
          CustomActionArea={SignUpFormContainer}
        />
      </div>

      <WebNav noLanguageSelector noActionsAvailable customLinks={customLinks} contextLink={false} CustomNavAction={GoToButton} />
      <main>{children}</main>
      <Footer links={customLinks} />
      <CookieMessage />
    </div>
  );
};

LandingPagesLayout.propTypes = {};

export default LandingPagesLayout;
